import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import database from "../config/FirbaseConfig";
import a from "../assets/samudaya/1.png";
import b from "../assets/samudaya/3.png";
import c from "../assets/samudaya/c.png";
import s from "../assets/samudaya/s.png";
import confetti from "canvas-confetti";


const slots = [
    { Date: 'Friday, 24th July, 2026', Time: "08:00PM - 10:00pm", Location: "36 Chapel Rd, Bandra" },
    { Date: 'Saturday, 25th July, 2026', Time: "12:00PM - 02:00PM", Location: "J49, Juhu" },
    { Date: 'Saturday, 25th July, 2026', Time: "03:00PM - 05:00PM", Location: "J49, Juhu" },
    { Date: 'Saturday, 25th July, 2026', Time: "05:30PM - 07:30PM", Location: "J49, Juhu" },
    { Date: 'Sunday, 26th July, 2026', Time: "12:00PM - 02:00PM", Location: "J49, Juhu" },
    { Date: 'Sunday, 26th July, 2026', Time: "03:00PM - 05:00PM", Location: "J49, Juhu" },
];

const RSVP = () => {
    const { invite } = useParams();
    const slot = decodeURI(invite)?.replace('i', '');
    const [yesOrNo, setYesOrNo] = useState(null); // null, true (yes), false (no)
    const [name, setName] = useState("");
    const [phone, setPhone] = useState("");
    const [count, setCount] = useState(null);
    const [dietary, setDietary] = useState(null);
    const [availableSeats, setAvailableSeats] = useState(0);
    const [message, setMessage] = useState(localStorage.getItem(`Samudaya9RSVPMessage`) || "");

    useEffect(() => {
        window.scrollTo(0, 0);
        const fetchSeats = async () => {
            try {
                const snapshot = await database.ref('s9rsvp').once('value');
                const rsvps = snapshot.val();
                let totalSeats = 0;
                for (let key in rsvps) {
                    if (rsvps[key].slot === slot && rsvps[key].coming) {
                        totalSeats += parseInt(rsvps[key].count, 10);
                    }
                }
                const maxSeats = 50;

                setAvailableSeats(maxSeats - totalSeats);
            } catch (error) {
                console.error("Error fetching seats:", error);
            }
        };

        fetchSeats();
    }, [slot]);

    const handleSubmit = async () => {
        // case 1: nothing selected
        if (yesOrNo === null) {
            alert("Please select Yes or No.");
            return;
        }

        // case 2: if No → confirm via window.confirm
        if (yesOrNo === false) {
            const confirmNo = window.confirm("Are you sure?");
            if (!confirmNo) return; // user cancelled
        }

        // case 3: if Yes → validate name & count
        if (yesOrNo === true) {
            if (!name.trim() || typeof count !== "number" || !count) {
                alert("Please fill in your name, phone number, and number of people before submitting.");
                return;
            }
        }
        let p1name = null;
        let p1phone = null;

        if (count >= 2) {
            p1name = window.prompt("Enter Name Of your +1");
            if (!p1name || !p1name.trim() || (p1name === name)) {
                alert("Please enter the name of your +1.");
                return;
            }
            if (p1name) {
                p1phone = window.prompt("Enter Phone Number Of your +1");
                if (!p1phone || (p1phone === phone)) {
                    alert("Please enter the phone number of your +1.");
                    return;
                }
            }
        }

        if (dietary === null) {
            alert("Please select dietary preference.");
            return;
        }

        // save to Firebase once
        try {
            await database.ref(`s9rsvp/${Date.now()}`).set({
                slot: slot,
                Date: slots?.[(slot - 1)]?.Date,
                Time: slots?.[(slot - 1)]?.Time,
                Location: slots?.[(slot - 1)]?.Location,
                coming: yesOrNo,
                name: yesOrNo ? name : null,
                phone: yesOrNo ? phone : null,
                count: yesOrNo ? count : null,
                dietary: yesOrNo ? dietary : null,
                submittedAt: new Date().toISOString(),
                status: yesOrNo ? (availableSeats - count >= 0 ? "Confirmed" : "Waitlist") : "Cancelled",
                id: Date.now(),
            });
            if (count >= 2) {
                await database.ref(`s9rsvp/${Date.now() + 1}`).set({
                    slot: slot,
                    Date: slots?.[(slot - 1)]?.Date,
                    Time: slots?.[(slot - 1)]?.Time,
                    Location: slots?.[(slot - 1)]?.Location,
                    coming: yesOrNo,
                    name: yesOrNo && p1name ? `${p1name} (${name}'s +1)` : null,
                    phone: yesOrNo && p1phone ? `${p1phone} (${phone}'s +1)` : null,
                    count: yesOrNo ? '+1' : null,
                    dietary: yesOrNo ? dietary : null,
                    submittedAt: new Date().toISOString(),
                    status: yesOrNo ? (availableSeats - count >= 0 ? "Confirmed" : "Waitlist") : "Cancelled",
                    id: Date.now(),
                });
            }

            confetti({
                particleCount: 125,
                startVelocity: 15,
                spread: 360,
                colors: ['#9E855F', '#9E855F', '#D1B171', '#FFF4E6'],
                origin: {
                    x: Math.random(),
                    y: Math.random() - 0.2
                }
            });

            confetti({
                particleCount: 100,
                startVelocity: 15,
                spread: 360,
                colors: ['#D1B171', '#FFF4E6', '#FFF'],
                origin: {
                    x: Math.random(),
                    y: Math.random() - 0.2
                }
            });


            confetti({
                particleCount: 55,
                startVelocity: 10,
                spread: 200,
                colors: ['#9E855F', '#D1B171', '#FFF4E6', '#FFF4E6'],
                origin: {
                    x: Math.random(),
                    y: Math.random()
                }
            });

            confetti({
                particleCount: 45,
                startVelocity: 5,
                spread: 250,
                colors: ['#9E855F', '#FFF4E6'],
                origin: {
                    x: Math.random(),
                    y: Math.random()
                }
            });

            confetti({
                particleCount: 35,
                startVelocity: 5,
                spread: 250,
                colors: ['#9E855F', '#FFF4E6'],
                origin: {
                    x: Math.random(),
                    y: Math.random()
                }
            });

            confetti({
                particleCount: 25,
                startVelocity: 5,
                spread: 250,
                colors: ['#9E855F', '#FFF4E6'],
                origin: {
                    x: Math.random(),
                    y: Math.random()
                }
            });

            // final messages
            if (yesOrNo) {
                setMessage(`Your table ${(availableSeats - count >= 0 ? "is Confirmed!\nSee you at Samudaya 9.0 on" : "is on the Waitlist, we'll get in touch by Friday for a confirmation for a slot on")} ${slots?.[slot - 1]?.Date} between ${slots?.[slot - 1]?.Time} at ${slots?.[slot - 1]?.Location}!`);
                localStorage.setItem(`Samudaya9RSVPMessage`, `Your table ${(availableSeats - count >= 0 ? "is Confirmed!\nSee you at Samudaya 9.0 on" : "is on the Waitlist, we'll get in touch for by Friday for a confirmation for a slot on")} ${slots?.[slot - 1]?.Date} between ${slots?.[slot - 1]?.Time} at ${slots?.[slot - 1]?.Location}!`);
            } else {
                setMessage("We'll miss you at Samudaya 9.0 💔");
                localStorage.setItem(`Samudaya9RSVPMessage`, "We'll miss you at Samudaya 9.0 💔");
            }
        } catch (err) {
            console.error("Error saving RSVP:", err);
            alert("Something went wrong while saving. Please try again.");
        }
    };
    return (
        <div style={{ width: '100vw', height: 'fit-content', minHeight: '100vh', padding: "5vw 2.5vh", textAlign: "center", display: "flex", flexWrap: 'wrap', justifyContent: "center", alignItems: "center", alignContent: "center", gap: "0px", background: '#FFF9E3', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundSize: '90vh 160vh', objectFit: 'cover', overflowX: 'hidden', position: 'relative' }}>
            <img src={a} alt='a' style={{ position: 'absolute', top: '0px', left: '0px', transform: 'translate(-35%, -25%)', width: '180px', height: '180px', objectFit: 'cover', animation: "spin1 15s linear infinite" }} />
            <img src={b} alt='c' style={{ position: 'absolute', top: '0vh', right: '0vh', transform: 'translate(30%, -20%) rotate(-55deg)', width: '180px', height: '180px', objectFit: 'cover', animation: "spin2 20s linear infinite" }} />
            <img src={c} alt='a' style={{ position: 'absolute', bottom: '-5px', left: '-5px', width: '245px', height: '245px', objectFit: 'cover', animation: "spin3 15s linear infinite" }} />
            <img src={s} alt='c' style={{ position: 'absolute', bottom: '-5px', right: '-5px', width: '245px', height: '245px', objectFit: 'cover', animation: "spin4 15s linear infinite" }} />
            <div style={{ width: '90vw', minHeight: '111', height: 'fit-content', padding: '5vh 0px', margin: '0px', border: '0px', borderRadius: '25px', display: 'flex', flexWrap: 'wrap', justifyContent: "center", alignItems: "start", alignContent: "start", overflowX: 'hidden', zIndex: 50 }}>
                <img src="https://firebasestorage.googleapis.com/v0/b/ettarracoffee-house.appspot.com/o/000%2FfullLogo.svg?alt=media&token=c78a54ee-fd7d-485b-a0d3-7f960f3485e6" alt="Ettarra Logo" style={{ width: '30vw', height: '15vh', objectFit: 'contain', marginBottom: '10px' }} />
                <div style={{ width: '80vw', height: 'fit-content', fontSize: '14px', fontWeight: '600', lineHeight: '14px', color: '#291A02', margin: '10px 0px' }}>Invitation to</div>
                <div style={{ width: '80vw', height: 'fit-content', fontSize: '36px', fontWeight: '900', lineHeight: '52px', color: '#291A02', margin: '5px 0px' }}><i>Samudaya 9.0</i></div>
                <div style={{ width: '80vw', height: 'fit-content', fontSize: '14px', fontWeight: '400', lineHeight: '14px', color: '#291A02', margin: '5px 0px' }}>The first taste of Samudaya 9.0 ✨
                    Join us for an exclusive preview, taste our new creations, and help shape the final menu!
                    Please Note: This only allows you to join the waitlist, your seat will be confirmed based on availability.</div>
                <div style={{ width: '80vw', height: 'fit-content', display: "flex", flexWrap: 'wrap', justifyContent: "center", alignItems: "center", fontSize: '16px', fontWeight: '700', lineHeight: '18px', color: '#291A02', margin: '5px 0px' }}>
                    <span style={{ width: '75vw' }}>Date: {slots?.[(slot - 1)]?.Date}</span>
                    <span style={{ width: '75vw' }}>Time: {slots?.[(slot - 1)]?.Time}</span>
                    <span style={{ width: '75vw' }}>Location: {slots?.[(slot - 1)]?.Location}</span>
                </div>
                <>
                    {message ? (
                        <p style={{ marginTop: "20px", fontSize: '20px', fontWeight: '900', lineHeight: '24px', color: '#291A02', padding: '10vw 5vw' }}><i>{message}</i></p>
                    ) : (<>
                        < div style={{ width: '80vw', height: 'fit-content', display: "flex", flexWrap: 'wrap', justifyContent: "space-between", alignItems: "end", alignContent: "end", marginTop: '3vh' }}>
                            <span style={{ width: '80vw', fontSize: '20px', padding: '5px 0', fontWeight: 900, lineHeight: '32px', color: '#291A02' }}><i>Are you coming?</i></span>
                            <div onClick={() => yesOrNo === false ? setYesOrNo(null) : setYesOrNo(false)} style={{ width: (yesOrNo === false ? '63vw' : yesOrNo !== null ? '15vw' : '39vw'), height: '15vw', margin: '5px 0px', backgroundColor: '#80000035', backdropFilter: 'blur(10px)', zIndex: '5', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '20vw', boxShadow: 'inset 1px 1px 20vw #ffffff55,1px 2px 2vw #291A0225', fontSize: yesOrNo === true ? '12px' : '20px', fontWeight: 900, lineHeight: '7vh', color: '#800000', textShadow: '1px 1px 45px #ffffff', border: yesOrNo !== true ? '2px solid #80000015' : null }}>No {yesOrNo === false ? <>&#10008;</> : ''}</div>
                            <div onClick={() => yesOrNo === true ? setYesOrNo(null) : setYesOrNo(true)} style={{ width: (yesOrNo === true ? '63vw' : yesOrNo !== null ? '15vw' : '39vw'), height: '15vw', margin: '5px 0px', backgroundColor: '#00800035', backdropFilter: 'blur(10px)', zIndex: '5', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '20vw', boxShadow: 'inset 1px 1px 20vw #ffffff55,1px 2px 2vw #291A0225', fontSize: yesOrNo === false ? '12px' : '20px', fontWeight: 900, lineHeight: '7vh', color: '#004f00ff', textShadow: '1px 1px 45px #ffffff', border: yesOrNo !== false ? '2px solid #00800015' : null }}>Yes {yesOrNo === true ? <>&#10004;</> : ''}</div>
                            <input type="text"
                                placeholder="Full Name"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                style={{ width: '80vw', height: yesOrNo === true ? '16vw' : '0px', padding: yesOrNo === true ? '0px 15px' : '0px', margin: yesOrNo === true ? '5px 0px' : '0px', fontSize: '16px', fontWeight: '700', lineHeight: '18px', color: '#291A02', backgroundColor: '#FFF9E375', backdropFilter: 'blur(10px)', border: '0px', borderRadius: '50px', boxShadow: '0px 0px 2vw #291A0255' }} />
                            <input type="tel"
                                placeholder="Phone Number"
                                value={phone}
                                onChange={(e) => setPhone(e.target.value)}
                                style={{ width: '80vw', height: yesOrNo === true ? '16vw' : '0px', padding: yesOrNo === true ? '0px 15px' : '0px', margin: yesOrNo === true ? '5px 0px' : '0px', fontSize: '16px', fontWeight: '700', lineHeight: '18px', color: '#291A02', backgroundColor: '#FFF9E375', backdropFilter: 'blur(10px)', border: '0px', borderRadius: '50px', boxShadow: '0px 0px 2vw #291A0255' }} />
                            {/* Dietary Preference */}
                            <div
                                style={{
                                    width: '80vw',
                                    display: yesOrNo === true ? 'flex' : 'none',
                                    justifyContent: 'space-between',
                                    margin: '5px 0px'
                                }}
                            >
                                {/* Veg */}
                                <div
                                    onClick={() => setDietary(dietary === 'Veg' ? null : 'Veg')}
                                    style={{
                                        width: dietary === 'Veg' ? '48vw' : dietary === 'Jain' ? '28vw' : '39vw',
                                        height: '16vw',
                                        backgroundColor: '#FFF9E375',
                                        borderRadius: '50px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '16px',
                                        fontWeight: '700',
                                        color: dietary === 'Veg' ? '#291A02' : dietary === 'Jain' ? '#291A0255' : '#291A02',
                                        boxShadow: '0px 0px 2vw #291A0255',
                                        border: dietary === 'Veg' ? '2px solid #291A02' : '2px solid transparent',
                                        cursor: 'pointer',
                                        transition: 'all 0.3s ease'
                                    }}
                                >
                                    Veg {dietary === 'Veg' && '✓'}
                                </div>

                                {/* Jain */}
                                <div
                                    onClick={() => setDietary(dietary === 'Jain' ? null : 'Jain')}
                                    style={{
                                        width: dietary === 'Jain' ? '48vw' : dietary === 'Veg' ? '28vw' : '39vw',
                                        height: '16vw',
                                        backgroundColor: '#FFF9E375',
                                        borderRadius: '50px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '16px',
                                        fontWeight: '700',
                                        color: dietary === 'Jain' ? '#291A02' : dietary === 'Veg' ? '#291A0255' : '#291A02',
                                        boxShadow: '0px 0px 2vw #291A0255',
                                        border: dietary === 'Jain' ? '2px solid #291A02' : '2px solid transparent',
                                        cursor: 'pointer',
                                        transition: 'all 0.3s ease'
                                    }}
                                >
                                    Jain {dietary === 'Jain' && '✓'}
                                </div>
                            </div>
                            <div
                                style={{
                                    width: '80vw',
                                    display: yesOrNo === true ? 'flex' : 'none',
                                    justifyContent: 'space-between',
                                    margin: '5px 0px'
                                }}
                            >
                                {/* Just Me */}
                                <div
                                    onClick={() => setCount(1)}
                                    style={{
                                        width: count === 1 ? '48vw' : count === 2 ? '28vw' : '39vw',
                                        height: '16vw',
                                        backgroundColor: '#FFF9E375',
                                        borderRadius: '50px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '16px',
                                        fontWeight: '700',
                                        color: count === 1 ? '#291A02' : count === 2 ? '#291A0255' : '#291A02',
                                        boxShadow: '0px 0px 2vw #291A0255',
                                        border: count === 1 ? '2px solid #291A02' : '2px solid transparent',
                                        cursor: 'pointer',
                                        transition: 'all 0.3s ease'
                                    }}
                                >
                                    Just Me {count === 1 && "✓"}
                                </div>

                                {/* +1 */}
                                <div
                                    onClick={() => setCount(2)}
                                    style={{
                                        width: count === 2 ? '48vw' : count === 1 ? '28vw' : '39vw',
                                        height: '16vw',
                                        backgroundColor: '#FFF9E375',
                                        borderRadius: '50px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '16px',
                                        fontWeight: '700',
                                        color: count === 2 ? '#291A02' : count === 1 ? '#291A0255' : '#291A02',
                                        boxShadow: '0px 0px 2vw #291A0255',
                                        border: count === 2 ? '2px solid #291A02' : '2px solid transparent',
                                        cursor: 'pointer',
                                        transition: 'all 0.3s ease'
                                    }}
                                >
                                    +1 {count === 2 && "✓"}
                                </div>
                            </div>
                            <div onClick={handleSubmit} style={{ width: '80vw', height: '16vw', margin: '5px 0px', backgroundColor: '#FFF9E3', zIndex: '5', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '20vw', boxShadow: 'inset 1px 1px 20vw #ffffff75,1px 2px 2vw #291A0235', fontSize: '24px', fontWeight: 900, lineHeight: '7vh', color: '#291A02', textShadow: '1px 1px 45px #ffffff' }}>Confirm</div>
                        </div>
                    </>)}
                </>
            </div>
        </div >
    );
};

export default RSVP;